module.exports = __webpack_public_path__ + "img/img-afiliacion.6f7f8108.png";